import { useState } from "react";
import { sql2text } from "../api";
import { Link } from "react-router-dom";

export default function SQL2Text() {
  const [sql, setSql] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [explanation, setExplanation] = useState("");
  const [result, setResult] = useState(null);
  const [limit, setLimit] = useState(20);
  const [run, setRun] = useState(false);

  const onConvert = async () => {
    setLoading(true); setError(""); setExplanation(""); setResult(null);
    try {
      const data = await sql2text(sql, run, limit);
      setExplanation(data.explanation || "");
      setResult(data.result ?? null);
    } catch (e) {
      setError((e && e.message) || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      {/* <div className="bg-white shadow">
        <div className="max-w-5xl mx-auto flex justify-between items-center p-4">
          <h1 className="font-bold text-xl">🗄️ SQL Tools</h1>
          <div className="space-x-4 text-gray-600">
            <Link to="/" className="hover:text-gray-900">Home</Link>
            <Link to="/text2sql" className="hover:text-gray-900">Text → SQL</Link>
            <Link to="/sql2text" className="text-blue-700">SQL → Text</Link>
          </div>
        </div>
      </div> */}

      <div className="max-w-2xl mx-auto p-8">
        <h1 className="text-2xl font-bold mb-4">SQL → Text</h1>
        <textarea
          value={sql}
          onChange={(e) => setSql(e.target.value)}
          rows={8}
          className="w-full p-3 border border-gray-300 rounded mb-4"
          placeholder="Enter SQL query"
        />
        {/* <div className="flex items-center gap-3 mb-4">
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={run} onChange={(e)=>setRun(e.target.checked)} />
            <span>Run query</span>
          </label>
          <input
            type="number"
            min={1}
            value={limit}
            onChange={(e)=>setLimit(parseInt(e.target.value || "20",10))}
            className="w-24 p-2 border border-gray-300 rounded"
          />
        </div> */}
        <button
          onClick={onConvert}
          disabled={loading || !sql.trim()}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? "Converting..." : "Convert to Text"}
        </button>

        {error && <div className="text-red-600 mt-4">{error}</div>}

      </div>
      <div className="max-w-7xl mx-auto px-6 py-8">

        {explanation && (
          <div className="mt-6">
            <h2 className="font-semibold">Explanation:</h2>
            <pre className="bg-gray-100 p-3 rounded text-sm mt-2 overflow-auto break-words whitespace-pre-wrap">{explanation}</pre>
          </div>
        )}

        {result && (
          <div className="mt-6">
            <h2 className="font-semibold">Result (preview):</h2>
            <pre className="bg-gray-100 p-3 rounded text-sm mt-2 overflow-auto break-words whitespace-pre-wrap">{JSON.stringify(result, null, 2)}</pre>
          </div>
        )}
      </div>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <h2 className="text-3xl font-bold text-center mb-10">How SQL → Text Works</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
          <div className="bg-white p-6 rounded-2xl shadow hover:shadow-lg transition">
            <h3 className="font-semibold text-lg mb-2">1️⃣ Paste Your SQL Query</h3>
            <p className="text-gray-600">Example:</p>
            <pre className="bg-gray-100 p-2 rounded mt-2 text-sm">SELECT name, country FROM customers WHERE country = 'UK';</pre>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow hover:shadow-lg transition">
            <h3 className="font-semibold text-lg mb-2">2️⃣ Click Convert</h3>
            <p className="text-gray-600">The AI engine parses the SQL query and understands its structure.</p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow hover:shadow-lg transition">
            <h3 className="font-semibold text-lg mb-2">3️⃣ Get Plain-English Output</h3>
            <p className="text-gray-600">Example:</p>
            <pre className="bg-gray-100 p-2 rounded mt-2 text-sm">Show the name and country of customers where the country is UK.</pre>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow hover:shadow-lg transition">
            <h3 className="font-semibold text-lg mb-2">4️⃣ Use Explanations</h3>
            <p className="text-gray-600">Understand queries quickly, explain them to teammates, or double-check logic.</p>
          </div>
        </div>
      </div>
    </main>
  );
}
